export default "__VITE_ASSET__ee5r3xm4__"